var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"svg",class:("relative icon-" + _vm.id + " sprite text-" + _vm.color + " " + _vm.classes),attrs:{"data-id":_vm.id}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":("#" + _vm.id)}})])}
var staticRenderFns = []

export { render, staticRenderFns }